/**
 * Retool's rename validation, ported verbatim from `modalEditIdentifier`'s
 * `textInput6` (EN-5166): `minLength=15`, `maxLength=15`,
 * `pattern="^\d+$"` — exactly 15 digits, i.e. an IMEI.
 *
 * ⚠️ Retool applied this on **rename only**. Its add-device form asked for an
 * identifier with nothing but `required`, so a device can be registered with
 * any identifier and then only renamed to a 15-digit one. That is ported as
 * it stands rather than tightened: `PatientDevicesPanel` is embedded by the
 * Patients pages, where non-cellular device types have their own serial
 * formats, and applying an IMEI rule there would block real registrations.
 * Worth a product decision — it is not obviously right either way.
 */
const IMEI_LENGTH = 15;
const DIGITS_ONLY = /^\d+$/;

export function validateDeviceIdentifier(value: string): string | undefined {
  const identifier = value.trim();
  if (!identifier) return "Enter an identifier.";
  if (!DIGITS_ONLY.test(identifier)) {
    return "The identifier must contain digits only.";
  }
  if (identifier.length !== IMEI_LENGTH) {
    return `The identifier must be exactly ${IMEI_LENGTH} digits.`;
  }
  return undefined;
}
